import { FC } from "react";
import { Link } from "react-router-dom";

import { AppLogo } from "../../assets";
import { PublicHeader } from "../../constants/headerLinks";
import MainNav from "./mainNav";



const GuestHeader: FC = (): JSX.Element => {
  return (
    <nav className="navbar navbar-expand-lg login-nav p-0 bg-light">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/users/sign_in"><img src={AppLogo} alt="Site logo" /></Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#hubHeader">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-start" id="hubHeader">
          <ul className="navbar-nav">
            {PublicHeader.map((headerLink, index) => (
              <MainNav headerLink={headerLink} key={index} />
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default GuestHeader;
